var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',{staticClass:"alt-pagination",attrs:{"id":_vm.id,"total-rows":_vm.total,"per-page":_vm.limit},on:{"change":_vm.change},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }